/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { Col, Row, Form, Select} from 'antd';
import './style.scss';
import { WorkflowContext, StepContext } from '../../Commons/Context';
import { keys as keycreate, isObject } from 'lodash';
import { PrimaryButton } from '../../Commons';
import { api } from '../../Http';
import { requiredRule, flatten } from '../../Commons/utils';
import { useHistory } from 'react-router-dom';

const isActiveOpt = [
    { label: 'True', value: 'true' },
    { label: 'False', value: 'false' },
  ];
const SalesProductCreateForm = () => {
    const { sampleData,
        SObject,
        mappings,
        workflowId,
        additionalQuery,
        setMappings,
        actionData,
        form } = useContext(WorkflowContext);
    const {
        id,
        //  next 
    } = useContext(StepContext);

    const [keys, setKeys] = useState([]);
    const [message, setMessage] = useState(undefined);
    const history = useHistory()


    const handleSkip = (maps) => {
        api.post('/api/v1/workflows/mappings', { mappings: maps, sObject: SObject, workflowId: workflowId, additionalQuery: additionalQuery })
            .then(resp => {
                setMessage(resp.data.message)
            })
            .catch(e => console.log(e));

        setTimeout(() => {
            history.push('/system/workflows');
        }, 1000)
    };

    useEffect(() => {
        setKeys(keycreate(sampleData));
        let tmp = {};
        mappings?.forEach((v) =>
            (v.type === 'TRIG')
                ?
                (
                    tmp[v.value] = [`${v.valueStepOrder}.${v.field}`],
                    tmp[v.label] = `${v.valueStepOrder}.${v.value}: ${sampleData[v.value]}`
                )
                :
                (v.type === 'ACT')
                    ?
                    (

                        tmp[v.field] = [`${v.valueStepOrder}.${v.value}`],
                        tmp[v.label] = `${v.valueStepOrder}.${v.field}: ${sampleData[v.value]}`
                    )
                    :
                    (tmp[v.field] = `${v.value}`)
        );
        if (tmp) {
            form.setFieldsValue(tmp);
        }
    }, []);

    const handleSubmit = () => {
        form
            .validateFields()
            .then((rawFormData) => {
                let MAPPINGS = [];

                let flatFormData = flatten({ ...rawFormData });
                keycreate(flatFormData)
                    .filter((k) => flatFormData[k] && !Array.isArray(flatFormData[k]))
                    .map((key) => {
                        if (Array.isArray(rawFormData[key]) && rawFormData[key].length === 0) {
                            // skip
                        } else {
                            let val = flatFormData[key]?.split('.');
                                let kname = val.length > 1 ? val[1] : val[0];
                                let snum = val.length > 1 ? val[0] : undefined;
                                MAPPINGS = snum ?
                                        [...MAPPINGS, { type: 'TRIG', value: key, field: kname, stepId: id, valueStepOrder: snum }]
                                        :
                                        [...MAPPINGS, { type: 'CON', value: flatFormData[key], field:key , stepId: id, valueStepOrder: 1 }];
                        
                        }
                        return key
                    });
                // Filter out duplicates based on 'field' and 'stepId'
                MAPPINGS = [...actionData, ...MAPPINGS].filter((v, i, a) => 
                    a.findIndex(t => (t.field === v.field && t.value === v.value && t.type === v.type)) === i
                );
                setMappings(MAPPINGS);
                handleSkip(MAPPINGS);
            })
            .catch((e) => console.log(e));
    };

    const RoundedSelect = (props) => {
        const { label, placeholder, name, required, specialOptions, specialOptionsOnly, hint, onSelect } = props;

        return (
            <Col span={22}>
                <div className='label'>
                    {label} <span className={required ? 'fr' : 'hidden'}>(required)</span>
                </div>
                <Form.Item name={name} required={required} rules={required ? [requiredRule] : null}>
                    <Select className='rounded' mode={specialOptions ? null : 'tags'}
                        placeholder={placeholder} allowClear onSelect={onSelect}>

                        {specialOptions && specialOptions.map((v) => <Select.Option key={v.value} value={v.value}>{v.label}</Select.Option>)}

                        {!specialOptionsOnly &&
                            keys.map(
                                (v, k) =>
                                    !isObject(sampleData[v]) && (
                                        <Select.Option value={`1.${v}`} key={`1.${k}`}>
                                            <div className='opt-div'>
                                                <span className='key'>{`1.${v}:  `}</span>
                                                {`${sampleData[v]}`}
                                            </div>
                                        </Select.Option>
                                    )
                            )}
                    </Select>
                </Form.Item>
                {hint && <div className='hint'>{hint}</div>}
            </Col>
        );
    };

    return (
        <Row className='padded xinvform'>
            <div className='title'> {'Create Woocommerce To Salesforce Field Mapping'} </div>
            <Col span={24}>

                <Form layout='vertical'
                    form={form}
                    scrollToFirstError={true}
                    onFinish={handleSubmit}
                    onValuesChange={() => console.log({ formData: form.getFieldsValue() })}

                >
                    <fieldset className='fieldset' style={{ border: '1px solid #e2e2e2' }}>
                    <legend>Product</legend>
                        <Row justify='center'>
                            <RoundedSelect label='Product Name' name='name' placeholder='Type or insert..' required />
                            <RoundedSelect label='Sku' name='sku' placeholder='Type or insert..'required />
                            <RoundedSelect label='Product Id' name='id' placeholder='Type or insert..' />
                            <RoundedSelect label='Type' name='type' placeholder='Type or insert..'/>
                            <RoundedSelect label='Active' name='IsActive' placeholder='Choose value..' specialOptions={isActiveOpt} specialOptionsOnly/>
                            <RoundedSelect label='Status' name='status' placeholder='Type or insert..'/>
                            <RoundedSelect label='Description' name='description' placeholder='Type or insert..'/>
                            <RoundedSelect label='Short Description' name='short_descriptione' placeholder='Type or insert..'/>
                            <RoundedSelect label='Tax Status' name='tax_status' placeholder='Type or insert..'/>
                            <RoundedSelect label='Created Date GMT' name='date_created_gmt' placeholder='Type or insert..'/>
                            <RoundedSelect label='Modified Date GMT' name='date_modified_gmt' placeholder='Type or insert..' />
                        </Row>
                    </fieldset>
                    <Row justify='center'>
                        <PrimaryButton className='btn-long' size='large' htmlType='submit'>
                                Continue
                        </PrimaryButton>
                    </Row>
                        
                </Form>
            </Col>
        </Row>
    );
};

export default SalesProductCreateForm;
